export default __webpack_public_path__ + "static/media/menu-module.90f427b7.png";